import { api } from "./client";
import type { ActionSpec, ActionSummary, CustomField } from "./types";

export const listActions = () => api<ActionSummary[]>("/api/actions");
export const getAction = (id: string) => api<ActionSummary>(`/api/actions/${id}`);

export const listCustomFields = () =>
  api<CustomField[]>("/api/custom-fields");

export interface ActionPayload {
  name: string;
  enabled: boolean;
  spec: ActionSpec;
}

export const createAction = (body: ActionPayload) =>
  api<{ id: string }>("/api/actions", {
    method: "POST",
    body: JSON.stringify(body),
  });

export const updateAction = (id: string, body: ActionPayload) =>
  api<ActionSummary>(`/api/actions/${id}`, {
    method: "PUT",
    body: JSON.stringify(body),
  });

export const disableAction = (id: string) =>
  api<ActionSummary>(`/api/actions/${id}`, { method: "DELETE" });

export const validateAction = (body: ActionPayload) =>
  api<{ ok: boolean; summary: Record<string, unknown> }>(
    "/api/actions/validate",
    { method: "POST", body: JSON.stringify(body) },
  );
